export default "__VITE_ASSET__Bc65H050__"